export default {
  methods: {
    resolveFirebaseQueryMap(queryMap, values) {
      const queries = {};
      queryMap.firebase_parameter.forEach((q) => {
        queries[q.query_parameter] = this.resolveTemplate(q.template, values);
      });
      return queries;
    },
    resolveQueryMap(queryMap, values) {
      const queries = {};
      queryMap.query_parameters.forEach((q) => {
        queries[q.query_parameter] = this.resolveTemplate(q.template, values);
      });
      return queries;
    },
    resolveTemplate(template, values) {
      return template
        .map((temp) => {
          if (temp.type === "field") {
            let id = temp.value;
            return this.resolveField(id, values[id]);
          } else if (temp.type === "field_sec") {
            let id = temp.value.slice(0, -1);
            return this.resolveField(id, values[`${id}_2`], true);
          } else if (temp.type === "text") {
            return temp.value || "";
          }
          return;
        })
        .join("");
    },
    resolveField(id, value, isSecondValue) {
      const field = this.campaignFields.find((field) => field.id === id);
      if (!field || !value) return "";
      if (isSecondValue && !field.has_second_list_value) return "";
      let resolved;
      if (field.input_type == "date") {
        resolved = this.transformDate(value, field);
      } else {
        resolved = this.transformValue(value, field.transform_to) || "";
        if (resolved) {
          resolved = field.prefix ? field.prefix + resolved : resolved;
          resolved = field.suffix ? resolved + field.suffix : resolved;
        }
      }
      return resolved;
    },
    transformValue(value, transform_to) {
      if (transform_to === "lowercase") {
        return value.toLowerCase();
      } else if (transform_to === "uppercase") {
        return value.toUpperCase();
      } else {
        return value;
      }
    },
    transformDate(value, field) {
      return this.$dayjs(value).format(field.date_format);
    },
  },
};
